// extracted by mini-css-extract-plugin
export var apps = "apps-module--apps--myKWn";
export var apps__media = "apps-module--apps__media--P8+iV";
export var apps__mobileApps = "apps-module--apps__mobile-apps--2X7gf";
export var apps__mobileAppsLink = "apps-module--apps__mobile-apps-link--Ed87P";
export var apps__gradient = "apps-module--apps__gradient--qTL8Z";